import { atom } from "recoil";

export const errorsWaitListState = atom({
  key: "errorsWaitList",
  default: {
    speciality: [],
    professional: [],
    fechaIni: [],
    fechaFin: [],
  },
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newValue) => {
        console.log("errorsWaitListState", newValue);
      });
    },
  ],
});

export const professionalsWaitListState = atom({
  key: "professionalsWaitList",
  default: [],
});

export const specialitiesWaitListState = atom({
  key: "specialitiesWaitList",
  default: [],
});

export const professionalWaitListState = atom({
  key: "professionalWaitList",
  default: {
    code: null,
    value: "",
    agp_correl: null,
  },
});

export const specialityWaitListState = atom({
  key: "specialityWaitList",
  default: {
    code: null,
    value: "",
  },
});

export const fechaIniWaitListState = atom({
  key: "fechaIniWaitList",
  default: "",
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newValue) => {
        console.log("fechaIniWaitListState", newValue);
      });
    },
  ],
});

export const fechaFinWaitListState = atom({
  key: "fechaFinWaitList",
  default: "",
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newValue) => {
        console.log("fechaFinWaitListState", newValue);
      });
    },
  ],
});

export const disabledSelectState = atom({
  key: "disabledSelect",
  default: false,
});

export const showWaitListState = atom({
  key: "showWaitList",
  default: false,
});
